import AppModal from '@components/AppModal';
import { ActivityComponentType } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

interface Params {
    storeUrl: string;
}

declare module '@stackflow/config' {
    interface Register {
        ForceUpdateModal: Params;
    }
}

const ForceUpdateModal: ActivityComponentType<'ForceUpdateModal'> = ({ params }) => {
    const { storeUrl } = params;
    const { t } = useTranslation('common');
    return (
        <AppModal title={t('forceUpdate.title')}
            confirm={t('forceUpdate.goToStore')}
            onConfirm={() => openExternalLink(storeUrl)}
            disableOutside />
    );
};

export default ForceUpdateModal;
